import { IconName } from '@fortawesome/fontawesome-common-types'
import { URL } from './url'

interface param {
  url: string
  title: string
  text: string
  icon: IconName
  image?: string
  indent_1: boolean
  indent_2: boolean
}

export const RISK_LIST: param[] = [
  {
    url: URL.RISK_TIMELINE.path,
    title: "タイムラインデータ",
    text: "対象日の行動を時系列順に表示します。",
    icon: "clock",
    image: "/static/images/risk/image_1.png",
    indent_1: false,
    indent_2: true,
  },
  {
    url: URL.RISK_MEMBER_LIST.path,
    title: "個人データ",
    text: "対象期間の個人に関するデータを表示します。",
    icon: "user",
    image: "/static/images/risk/image_2.png",
    indent_1: false,
    indent_2: true,
  },
  {
    url: URL.RISK_TEAM_LIST.path,
    title: "チームデータ",
    text: "対象期間のチームに関するデータを表示します。",
    icon: "users",
    image: "/static/images/risk/image_3.png",
    indent_1: false,
    indent_2: true,
  },
  {
    url: URL.RISK_CUSTOM_ALERT.path,
    title: "カスタムアラート",
    text: "条件を指定してアラートメールを送信できます。",
    icon: "users",
    image: "/static/images/risk/image_4.png",
    indent_1: false,
    indent_2: true,
  },
]

export default RISK_LIST
